import React, { createContext, useState, useEffect, useContext } from "react";
import { loginUser,admin_loginUser,registerUser,logoutUser } from '../controllers/authController';
import { useNavigate } from 'react-router-dom';
import { AlertContext } from './AlertContext';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [artist, setArtist] = useState(null);
  const [authLoading, setLoading] = useState(true);  // Loading state
  const navigate = useNavigate();
  const { showAlert } = useContext(AlertContext);


  useEffect(() => {
    const token = localStorage.getItem("TOKEN");
    if (token) {
      setIsAuthenticated(true);
      const role=localStorage.getItem("ROLE");
      if(role==="admin"){
        console.log("setting admin");
        setIsAdmin(true);
      }
    }
    setLoading(false); // ✅ Done checking
  }, []);
  
  useEffect(() => {
    const token = localStorage.getItem("TOKEN");
    const role=localStorage.getItem("ROLE");

    console.log(token," ",role);
    if(token!==null){
      setIsAuthenticated(true);
      if(role=="admin"){
        console.log("setting admin");
        setIsAdmin(true);
      }
      else{
         setIsAdmin(false);
          const artistData=localStorage.getItem("ARTIST");
          if(artistData){
            setArtist(JSON.parse(artistData));
          }
      }
    }
    setLoading(false);
  }, [isAdmin,isAuthenticated]);


  const login = async (email, password) => {
    setLoading(true);
    try {
      console.log("Logging in with email:", email, "and password:", password);
      const response = await loginUser(email, password);
      setArtist(response.artist);
      setIsAuthenticated(true);
      setLoading(false);
      showAlert("Login Successful!", "success");
      navigate('/dashboard');
      return true;
    } catch (error){
      setLoading(false);
      showAlert("Login Failed. Please check your credentials.", "danger");
      console.log("Error in login",error);
      return false;
    }
  };

  const admin_login = async (username, password) => {
    setLoading(true);
    try {
      console.log("Logging in with username:", username, "and password:", password);
      const response = await admin_loginUser(username, password);
      setIsAuthenticated(true);
      console.log("Admin login response:", response);
      setLoading(false);
      showAlert("Login Successful!", "success");
      navigate('/admin_dashboard', { state: { fromLogin: true } });
      return true;
    } catch (error){
      setLoading(false);
      showAlert("Login Failed. Please check your credentials.", "danger");
      console.log("Error in login",error);
      return false;
    }
  };

  const logout = () => {
    setLoading(true);
    logoutUser();
    setIsAuthenticated(false);
    setLoading(false);
    showAlert("Logout Successful!", "success");
    return true;
  };  



  const register = async (name,email,password) => {
    setLoading(true);
    try{
      const resp=await registerUser(name,email,password);
      setIsAuthenticated(true); 
      setLoading(false);
      console.log("sending auth success");
      showAlert("Register Successful!", "success");
      navigate('/dashboard');
      return true;
    }catch(error){
      setLoading(false);
      showAlert("Registration Failed. Please try again.", "danger");
      console.log("Error in register",error);
      return false;
    }
  }; 
  

  
 

  return (
    <AuthContext.Provider value={{ isAuthenticated,isAdmin,authLoading,login,logout,register,admin_login,artist}}>
      {children}
    </AuthContext.Provider>
  );
};
